/**
 * AI 에이전트 — **마지막으로 보던 대화**를 기억한다(사용자 요청 2026-10-13).
 *
 * 대화 내용은 서버에 남아 있는데, 화면을 새로 고치면 패널이 늘 「새 대화」 로 시작해 내용이 사라진 것처럼 보였다(목록에서 다시 골라야 했다).
 * 여기는 「어느 대화를 보고 있었나」 만 이 브라우저에 적어 둔다 — 대화 내용은 적지 않는다(내용은 서버에서 다시 받는다).
 *
 *  · 적는 것은 대화 id 하나. 직접 「새 대화」 를 고르면 지운다 — 새로 고쳐도 새 대화에서 시작한다.
 *  · 되살릴 때는 **서버가 준 내 대화 목록에 그 id 가 있을 때만** — 지운 대화·다른 계정의 대화는 조용히 무시한다.
 *  · 저장소를 못 쓰면(사생활 보호 창 등) 그냥 예전처럼 새 대화로 시작한다.
 */
const KEY = 'livesql_assistant_last_thread';

export function rememberLastThread(id) {
  try { if (id) localStorage.setItem(KEY, String(id)); } catch (_e) { /* 못 적어도 대화는 그대로 된다 */ }
}

export function forgetLastThread() {
  try { localStorage.removeItem(KEY); } catch (_e) { /* 위와 같다 */ }
}

export function readLastThread() {
  try { return localStorage.getItem(KEY) || null; } catch (_e) { return null; }
}

/**
 * 되살릴 대화 id — **순수 함수**. 없으면 null.
 * @param saved    적어 둔 id
 * @param threads  서버가 준 내 대화 목록 [{ id }]
 * @param current  지금 열려 있는 대화 id(있으면 건드리지 않는다)
 */
export function threadToRestore(saved, threads, current) {
  if (current || !saved) return null;
  return (threads || []).some(x => x && x.id === saved) ? saved : null;
}
